
    var riot = require('riot')
    //src: starling/src/tags/presentation-controls.html
riot.tag2('presentation-controls',
  '<div ref="controlsBox" class="display-none hidden controls-box"> <i if="{!this.isPaused()}" class="button prev-button material-icons" onmouseleave="{unhighlightAll}" onclick="{handlePrevClick}"> arrow_left </i> <i if="{!this.isPaused()}" class="button next-button material-icons" onmouseleave="{unhighlightAll}" onclick="{handleNextClick}"> arrow_right </i> </div>',
  '',
  'ref="main" onmouseenter="{setHovered}" onmouseleave="{unsetHovered}"', function(opts) {
'use strict';

var _this = this;

var _presentationUi = require('lib/presentation-ui');

var _presentationUi2 = _interopRequireDefault(_presentationUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = this.opts.canvas;

canvas.presentationControlsTag = this;

this.isPaused = function () {
  return _presentationUi2.default.isPaused();
};

this.setHovered = function () {
  _this.hovered = true;
};

this.unsetHovered = function () {
  _this.hovered = false;
};

this.handlePrevClick = function () {
  _presentationUi2.default.prev();
};

this.handleNextClick = function () {
  _presentationUi2.default.next();
};

this.show = function () {
  _this.refs.controlsBox.classList.remove('hidden');
};

this.hide = function () {
  _this.refs.controlsBox.classList.add('hidden');
};

this.on('mount', function () {
  var bottomBannerContainer = document.querySelector('.app_banners.app_banners--bottom');
  bottomBannerContainer.appendChild(_this.refs.main);
});

this.setup = function () {
  _this.refs.controlsBox.classList.remove('display-none');
};

this.shutdown = function () {
  _this.refs.controlsBox.classList.add('display-none');
};

this.unhighlightAll = function () {
  canvas.waypointIndicationBoxTag.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('presentation-controls')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/presentation-controls.html
// module id = 674
// module chunks = 0